var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit5 = function SvgEdit5(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5H7.875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 1.31258C6.33668 1.1634 6.53902 1.07959 6.75 1.07959C6.85447 1.07959 6.95791 1.10017 7.05442 1.14014C7.15094 1.18012 7.23863 1.23872 7.3125 1.31258C7.38637 1.38645 7.44496 1.47415 7.48494 1.57066C7.52492 1.66718 7.5455 1.77062 7.5455 1.87508C7.5455 1.97955 7.52492 2.08299 7.48494 2.17951C7.44496 2.27602 7.38637 2.36372 7.3125 2.43759L2.625 7.12509L1.125 7.50009L1.5 6.00009L6.1875 1.31258Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-5.049f9807.svg";
export { ForwardRef as ReactComponent };